import { defineMetrics } from "../types.js"

export const productsMetrics = defineMetrics([
  {
    id: "total_products",
    name: "Total Products",
    description: "Total number of Products in the Products module.",
    logic: "Count all active Product records.",
    source: "product.countDocuments() —— the live collection, not productSnapshot",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: true,
    xlsxRow: 16,
  },
  {
    id: "total_product_families",
    name: "Total Product Families",
    description: "Total number of Product Families.",
    logic: "Count all Product Family records.",
    source: "productFamily.countDocuments()",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: true,
    xlsxRow: 17,
  },
  {
    id: "total_product_solutions",
    name: "Total Product Solutions",
    description: "Total number of Product Solutions.",
    logic: "Count all Product Solution records.",
    source: "productSolution.countDocuments()",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: true,
    xlsxRow: 18,
  },
  {
    id: "total_skus",
    name: "Total SKUs",
    description: "Total number of SKUs associated with Products.",
    logic: "Count all SKU records.",
    source: "sku.countDocuments() —— the live collection, not skuSnapshot",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: true,
    xlsxRow: 19,
  },
  {
    id: "products_added",
    name: "Products Added",
    description: "Number of Products created during the reporting period.",
    logic: "Count Products with creation date within the selected period.",
    source: "product.createdAt, bucketed by period",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stat-tile"],
    coveredByV1: true,
    xlsxRow: 20,
  },
  {
    id: "product_families_added",
    name: "Product Families Added",
    description: "Number of Product Families created during the reporting period.",
    logic: "Count Product Families created during the selected period.",
    source: "productFamily.createdAt, bucketed by period",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stat-tile"],
    coveredByV1: true,
    xlsxRow: 22,
  },
  {
    id: "product_solutions_added",
    name: "Product Solutions Added",
    description: "Number of Product Solutions created during the reporting period.",
    logic: "Count Product Solutions created during the selected period.",
    source: "productSolution.createdAt, bucketed by period",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stat-tile"],
    coveredByV1: true,
    xlsxRow: 24,
  },
  {
    id: "total_country_sets",
    name: "Total Country Sets",
    description: "Total number of Country Sets.",
    logic: "Count all Country Set records.",
    source: "countrySet.countDocuments()",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: true,
    xlsxRow: 26,
  },
  {
    id: "countries_per_country_set",
    name: "Countries per Country Set",
    description: "List of countries included within each Country Set.",
    logic: "Retrieve all country assignments for each Country Set.",
    source: "$size(countrySet.countries), one point per set",
    domain: "products",
    srvModule: "products",
    priority: "must",
    valueType: "count",
    dims: ["entity"],
    rollup: "last",
    defaultWidget: "histogram",
    altWidgets: ["table", "hbar"],
    coveredByV1: false,
    xlsxRow: 27,
  },
])
